<template>
  <div class="question-container">
    <div style="width: 1200px;margin: 0 auto">
      <div class="title">{{$t('400150')}}</div>
      <div class="label-list">
        <div class="item bold pointer" :class="{ active: state1 === 0 }" @click="state1 = 0">{{$t('400151')}}</div>
        <div class="item bold pointer" :class="{ active: state1 === 1 }" @click="state1 = 1">{{$t('400152')}}</div>
      </div>
      <div class="buy-sell">
        <div class="item-list" v-if="state1 === 0">
          <div class="item">
            <img :src="isMoon ? xiadan_hei : xiadan" alt />
            <div class="item-title">{{$t('400153')}}</div>
            <div class="item-des">{{$t('400154')}}</div>
          </div>
          <div class="item">
            <img :src="isMoon ? buy_hei : buy" alt />
            <div class="item-title">{{$t('400155')}}</div>
            <div class="item-des">{{$t('400156')}}</div>
          </div>
          <div class="item">
            <img :src="isMoon ? get_hei : get" alt />
            <div class="item-title">{{$t('400157')}}</div>
            <div class="item-des">{{$t('400158')}}</div>
          </div>
        </div>
        <div class="item-list" v-else>
          <div class="item">
            <img :src="isMoon ? xiadan_hei : xiadan" alt />
            <div class="item-title">{{$t('400153')}}</div>
            <div class="item-des">{{$t('400154')}}</div>
          </div>
          <div class="item">
            <img :src="isMoon ? success_hei : success" alt />
            <div class="item-title">{{$t('400159')}}</div>
            <div class="item-des">{{$t('400160')}}</div>
          </div>
          <div class="item">
            <img :src="isMoon ? run_hei : run" alt />
            <div class="item-title">{{$t('400161')}}</div>
            <div class="item-des">{{$t('400162')}}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    status: Number,
  },
  data() {
    return {
      state1: this.status,
      xiadan: require("@/assets/img/xiadan.png"),
      xiadan_hei: require("@/assets/img/xiadan_hei.png"),
      buy: require("@/assets/img/buy.png"),
      buy_hei: require("@/assets/img/buy_hei.png"),
      get: require("@/assets/img/get.png"),
      get_hei: require("@/assets/img/get_hei.png"),
      success: require("@/assets/img/success.png"),
      success_hei: require("@/assets/img/success_hei.png"),
      run: require("@/assets/img/run.png"),
      run_hei: require("@/assets/img/run_hei.png"),
    };
  },
  watch: {
    status(v) {
      this.state1 = v;
    },
  },
  computed: {
    isMoon() {
      return this.$store.state.user.styleType == "moon";
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/mixin.scss";
@import "@/assets/css/variable.scss";
.question-container {
  margin-top: 60px;
  padding: 48px 0;
  position: relative;
  @include background_color('input-bg-color');
  .title {
    font-size: 32px;
    font-weight: bold;
    margin-bottom: 36px;
    @include font-color("font-color");
  }
  .label-list {
    margin-bottom: 64px;
    display: flex;
    .item {
      min-width: 157px;
      width: auto;
      text-align: center;
      border-radius: 16px;
      background: #f5f6f7;
      padding: 8px 12px;
      @include font_color('font-color-1');
      @include background_color('button-bg-normal');
      &.active {
        color: #000922;
        background: #ffc72b;
      }
    }
  }
  .buy-sell {
    .item-list {
      display: flex;
      justify-content: space-between;
      .item {
        width: 386px;
        img {
          width: 60px;
          height: 60px;
        }
        &-title {
          font-size: 23px;
          font-weight: bold;
          margin: 32px 0 16px;
          @include font-color("font-color");
        }
        &-des {
          @include font-color("font-color-2"); //allen
          font-size: 12px;
          line-height: 18px;
        }
      }
    }
  }
}
</style>
<style lang="scss">
[dir = 'ltr'] .question-container {
  .label-list {
    .item {
      margin-right: 26px;
    }
  }
}
[dir = 'rtl'] .question-container {
  .label-list {
    .item {
      margin-left: 26px;
    }
  }
}
</style>